

export class OperationCompletionModel {
    operationId: string;
    operationDesc: string;
    garmentsCompletedForOperation: number;

    constructor(operationId: string,
        operationDesc: string,
        garmentsCompletedForOperation: number) {
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.garmentsCompletedForOperation = garmentsCompletedForOperation;
    }
}